import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"absolute","top":"10px"}
}

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  category: string;
  // validate有無
  isValidate?: boolean;
  disabled?: boolean;
}

interface CategorySelect {
  label: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CategorySelects',
  props: {
    category: {},
    isValidate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['selectCategory'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const router = useRouter();
const emit = __emit;

// カテゴリープルダウン
const options = ref<CategorySelect[]>([]);
// Loading
const isLoading = ref(false);

// カテゴリー選択値
const selectCategory = computed({
  get: () => props.category,
  set: (value) => {
    emit('selectCategory', value || '');
  },
});

/**
 * カテゴリーリスト取得
 */
const getCategory = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/categories')
    .then((res) => {
      const { common, categoryOptions } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          options.value = categoryOptions;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};

/**
 * 初期表示処理
 */
getCategory();

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: selectCategory.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectCategory).value = $event)),
    options: options.value,
    outlined: "",
    dense: "",
    clearable: "",
    "emit-value": "",
    "map-options": "",
    disable: props.disabled,
    loading: isLoading.value,
    style: {"background":"var(--q-white)","padding":"0"},
    rules: props.isValidate ? [(val) => !!val || _ctx.$t('validation.required')] : undefined
  }, {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("該当するカテゴリーはありません")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (!selectCategory.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "text-dark" }, "選択してください", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "disable", "loading", "rules"]))
}
}

})